import { request } from "api"
import { SWRConfiguration } from "swr"

export const swrDefaults: SWRConfiguration = {
    fetcher: request,
    loadingTimeout: 10000,
    revalidateIfStale: true,
    revalidateOnFocus: true,
    revalidateOnReconnect: true,
    refreshInterval: 180000, // Refresh data every 3 mins
    dedupingInterval: 10000,
    focusThrottleInterval: 60000,
}
